export default __webpack_public_path__ + "static/media/sad-face.29f7effd.svg";